import { getBrowserLoginRequest } from './browserLogin';

/** Returns only the internal workspace-selection route used by browser authorization. */
export const getAuthorizationReturn = (
  value: string | undefined
): string | undefined => {
  if (!value?.startsWith('/authorize?')) return undefined;
  const url = new URL(value, window.location.origin);
  const isIssuerRequest =
    !!url.searchParams.get('issuer_state') &&
    !!url.searchParams.get('pod') &&
    !url.searchParams.has('redirect_uri');
  // A continuation either names a regional issuer request or a loopback discovery callback.
  if (
    url.origin !== window.location.origin ||
    url.pathname !== '/authorize' ||
    (!isIssuerRequest && !getBrowserLoginRequest(url.searchParams))
  )
    return undefined;
  return `${url.pathname}${url.search}`;
};
